var _rect, _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _circle4, _circle5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopsharerLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 449,
    viewBox: "0 0 382 449",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.3,
    y: 9,
    width: 242,
    height: 267,
    rx: 96,
    stroke: "black",
    strokeWidth: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.498 57.0568C132.98 60.5272 122.878 94.3907 127.328 108.85C118.974 113.096 103.004 124.382 105.963 133.914C121.987 125.696 123.22 126.107 124.452 126.929C125.685 127.751 98.9776 147.473 103.908 157.745C117.878 148.295 121.987 145.419 123.22 146.651C124.452 147.884 103.908 167.606 110.893 175.413C117.056 169.25 118.289 166.785 121.987 166.785C125.685 166.785 117.878 180.754 120.343 183.22H190.818H260.257C262.722 180.754 254.915 166.785 258.613 166.785C262.311 166.785 263.544 169.25 269.707 175.413C276.692 167.606 256.148 147.884 257.381 146.651C258.613 145.419 262.722 148.295 276.692 157.745C281.622 147.473 254.915 127.751 256.148 126.929C257.38 126.107 258.613 125.696 274.638 133.914C277.596 124.382 261.626 113.096 253.272 108.85C257.722 94.3907 247.696 60.5272 242.178 57.0568C235.02 52.5551 215.005 82.6316 209.64 94.851H190.407H170.96C165.595 82.6316 145.656 52.5551 138.498 57.0568Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 8,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.418 139.189C185.294 132.615 186.526 107.551 190.224 107.551C190.224 108.897 192.5 132.5 190.224 146.174C184.746 147.132 174.092 148.285 176.026 146.995C178.491 145.352 180.363 143.884 182.418 139.189Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.754 139.189C194.878 132.615 193.922 107.551 190.224 107.551C190.224 108.783 186 133 190.224 146.174C195.703 147.132 207.543 148.285 205.61 146.995C203.144 145.352 199.808 143.884 197.754 139.189Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 154.249,
    cy: 139.599,
    r: 6.5741,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.386,
    cy: 139.599,
    r: 6.5741,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.7073,
    cy: 26.7073,
    r: 26.7073,
    transform: "matrix(1 0 0 -1 164.11 195.935)",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194.517 164.528C192.529 167.398 188.285 167.398 186.297 164.528L183.034 159.818C180.736 156.502 183.11 151.97 187.144 151.97L193.67 151.97C197.704 151.97 200.078 156.502 197.78 159.818L194.517 164.528Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9842 200.832C19.121 185.146 32.1785 173 47.9058 173H333.694C349.421 173 362.479 185.146 363.616 200.832L379.269 416.832C380.528 434.209 366.77 449 349.347 449H32.2528C14.8302 449 1.0719 434.209 2.33117 416.832L17.9842 200.832Z",
    fill: "#E0157A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.3,
    cy: 210,
    r: 15,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.3,
    cy: 210,
    r: 15,
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopsharerLogo);
export default __webpack_public_path__ + "static/media/shopsharer-logo.625115ada4d23fb9e2076befea053baa.svg";
export { ForwardRef as ReactComponent };